import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import {
  ISSUE_ASSIGNEE_CHANGE_EXTENSION,
  ISSUE_ASSIGNMENT_CHANGED_ACTIVITY_TYPE_EXTENSION,
  ISSUE_CREATED_ACTIVITY_TYPE_EXTENSION,
  ISSUE_DELETED_ACTIVITY_TYPE_EXTENSION,
  ISSUE_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION,
  ISSUE_STATE_CHANGE_EXTENSION,
  ISSUE_STRING_CHANGE_EXTENSION,
  ISSUE_SURFACES_CHANGE_EXTENSION,
  ISSUE_UPDATED_ACTIVITY_TYPE_EXTENSION,
  TASK_CREATED_ACTIVITY_TYPE_EXTENSION,
  TASK_DELETED_ACTIVITY_TYPE_EXTENSION,
  TASK_INPUT_REQUESTED_ACTIVITY_TYPE_EXTENSION,
  TASK_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION,
  TASK_STATE_CHANGE_EXTENSION,
  TASK_STRING_CHANGE_EXTENSION,
  TASK_UPDATED_ACTIVITY_TYPE_EXTENSION,
} from './components/IssueActivitySection/extensions';
import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const issuesPlugin = createPlugin({
  id: 'issues',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindIssuesRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(issuesPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceIssuesPage = issuesPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceIssuesPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-issues", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const IssueAssigneeChangeExtension = issuesPlugin.provide(
  ISSUE_ASSIGNEE_CHANGE_EXTENSION,
);
export const IssueStateChangeExtension = issuesPlugin.provide(
  ISSUE_STATE_CHANGE_EXTENSION,
);
export const IssueSurfacesChangeExtension = issuesPlugin.provide(
  ISSUE_SURFACES_CHANGE_EXTENSION,
);
export const IssueStringChangeExtension = issuesPlugin.provide(
  ISSUE_STRING_CHANGE_EXTENSION,
);
export const TaskStateChangeExtension = issuesPlugin.provide(
  TASK_STATE_CHANGE_EXTENSION,
);
export const TaskStringChangeExtension = issuesPlugin.provide(
  TASK_STRING_CHANGE_EXTENSION,
);

export const IssueCreatedActivityTypeExtension = issuesPlugin.provide(
  ISSUE_CREATED_ACTIVITY_TYPE_EXTENSION,
);
export const IssueStateChangedActivityTypeExtension = issuesPlugin.provide(
  ISSUE_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION,
);
export const IssueAssignmentChangedActivityTypeExtension = issuesPlugin.provide(
  ISSUE_ASSIGNMENT_CHANGED_ACTIVITY_TYPE_EXTENSION,
);
export const IssueUpdatedActivityTypeExtension = issuesPlugin.provide(
  ISSUE_UPDATED_ACTIVITY_TYPE_EXTENSION,
);
export const IssueDeletedActivityTypeExtension = issuesPlugin.provide(
  ISSUE_DELETED_ACTIVITY_TYPE_EXTENSION,
);
export const TaskCreatedActivityTypeExtension = issuesPlugin.provide(
  TASK_CREATED_ACTIVITY_TYPE_EXTENSION,
);
export const TaskStateChangedActivityTypeExtension = issuesPlugin.provide(
  TASK_STATE_CHANGED_ACTIVITY_TYPE_EXTENSION,
);
export const TaskInputRequestedActivityTypeExtension = issuesPlugin.provide(
  TASK_INPUT_REQUESTED_ACTIVITY_TYPE_EXTENSION,
);
export const TaskUpdatedActivityTypeExtension = issuesPlugin.provide(
  TASK_UPDATED_ACTIVITY_TYPE_EXTENSION,
);
export const TaskDeletedActivityTypeExtension = issuesPlugin.provide(
  TASK_DELETED_ACTIVITY_TYPE_EXTENSION,
);
